import React from 'react';
import { useLocation } from 'react-router-dom';
import DashboardView from './Admin/DashboardView';
import ArchivedPage from './Admin/ArchivedPage';
import TemplateManagement from './Admin/TemplateManagement';
import AdminPageLayout from './AdminPageLayout';
import ViewSurvey from './Admin/ViewSurvey';
import CreateSurvey from './Admin/CreateSurvey';
import WaveOverview from './Admin/WaveOverview';
import InstanceOverview from './Admin/InstanceOverview';

const AdminDashboard = () => {
    const location = useLocation();
    const stateView = location.state?.view;

    const views = {
        DashboardView: <DashboardView />,
        ArchivedPage: <ArchivedPage />,
        TemplateManagement: <TemplateManagement />,
        ViewSurvey: <ViewSurvey />,
        CreateSurvey: <CreateSurvey />,
        WaveOverview: <WaveOverview/>,
        InstanceOverview: <InstanceOverview/>,
    };

    // Fallback to default view if no state is passed
    const currentView = stateView && views[stateView] ? stateView : 'DashboardView';

    return (
        <AdminPageLayout
            views={views}
            defaultView={currentView}
            title="Dashboard"
        />
    );
};

export default AdminDashboard;
